// extracted by mini-css-extract-plugin
export var card = "_6a-0";
export var failedIcon = "_6a-4";
export var failedIconBadge = "_6a-3";
export var icon = "_6a-1";
export var successIcon = "_6a-2";